// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_AtualizaStatusOrcamentoAposCheckinResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /orcamentos/atualiza_status_orcamento_apos_checkin/{id}
 *
 * Returns success message after updating orcamento status post-checkin.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orcamentos_AtualizaStatusOrcamentoAposCheckinResponseDados {
message: string
}

export type Orcamentos_AtualizaStatusOrcamentoAposCheckinResponse = ApiResponse<Orcamentos_AtualizaStatusOrcamentoAposCheckinResponseDados>;

registerResponseContract('Orcamentos_AtualizaStatusOrcamentoAposCheckinResponse', {
  message: { type: 'string',  required: false },
})
